/**
 * Google vector basemaps own building rendering. The previous Mapbox
 * fill-extrusion layer has no direct source/layer equivalent in Google Maps.
 */
export function GoogleBuildingsLayer() {
  return null
}
